import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Store } from '@ngrx/store';

import { ROUTE_ANIMATIONS_ELEMENTS } from '../../../../core/core.module';

import { State } from '../../../vista-usuario/vista-usuario.state';


@Component({
  selector: 'rpe-vista-vinculos-container',
  templateUrl: './vista-vinculos-container.component.html',
  styleUrls: ['./vista-vinculos-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VistaVinculosContainerComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;

  constructor(private store: Store<State>) {}

  ngOnInit(): void {
    // todo - hacer este dispatch singleton
  }
}
